/** @format */

export default {
    SCRIPT_URL: 'https://apps.rokt.com/wsdk/integrations/launcher.js',
    SCRIPT_ID: 'rokt-launcher',
    ACCOUNT_ID: '3148152371751954573',
};
